import React from 'react';
import DashboardIcon from "@material-ui/icons/Dashboard";
import GroupIcon from "@material-ui/icons/Group";
import { MdDashboard, MdHome, MdMenu, MdOutlineAdminPanelSettings, MdOutlineBorderStyle, MdOutlineDirectionsTransit, MdOutlineFileDownload, MdOutlineInventory2, MdOutlineStorefront, MdPeopleOutline, MdSettings, } from 'react-icons/md';
import { HiOutlineDocumentReport, HiOutlineNewspaper } from "react-icons/hi";
import { BiMessageDetail, BiWallet } from 'react-icons/bi';

/**
 * The tabs, in four groups.
 *
 * Ten identical rows was a wall — Vendors, Stock and Expenses looked like the
 * same kind of thing as Home. `startsGroup` puts a hairline above a row, which
 * is all the separation a 65px rail can carry: collapsed, the tabs are icons
 * and a line is the only thing that can group them without a label.
 *
 * Groups, in the order of a day: Selling · Books · Store · Insight, then
 * Adminstration on its own.
 *
 * Layout.js draws the lines. A waiter is filtered down to Home alone, so they
 * see none of them.
 */
export const SidebarData = [
  /* ── Selling ─────────────────────────────────────────────────────────────
     What the till does all day. */
  {
    text: "Home",
    icon: <MdHome  style={{fontSize: "20px", color: "grey"}} />,
    path: "/orders",
  },
  {
    text: "Orders",
    icon: <MdOutlineDirectionsTransit  style={{fontSize: "20px", fontWeight: "none", color: "grey"}} />,
    path: "/orderlist",
  },
  {
    text: "Menu",
    icon: <MdMenu  style={{fontSize: "20px",}} />,
    path: "/menu",
  },

  /* ── Books ───────────────────────────────────────────────────────────────
     Money owed in, owed out, and spent. */
  {
    text: "Customers",
    icon: <MdPeopleOutline  style={{fontSize: "20px", color: "grey"}} />,
    path: "/customers",
    startsGroup: true,
  },
  {
    text: "Vendors",
    icon: <MdOutlineStorefront  style={{fontSize: "20px", color: "grey"}} />,
    path: "/vendors",
  },
  {
    text: "Expenses",
    icon: <BiWallet  style={{fontSize: "20px", color: "grey"}} />,
    path: "/expenses",
  },

  /* ── Store ───────────────────────────────────────────────────────────────
     On its own: it is its own world, and a storekeeper sees only this. */
  {
    text: "Stock",
    icon: <MdOutlineInventory2  style={{fontSize: "20px", color: "grey"}} />,
    path: "/stock",
    startsGroup: true,
  },

  /* ── Insight ─────────────────────────────────────────────────────────────
     Read, never typed into. */
  {
    text: "Dashboard",
    icon: <MdDashboard  style={{fontSize: "20px", color: "grey"}} />,
    path: "/dashboard",
    startsGroup: true,
  },
  {
    text: "Reports",
    icon: <HiOutlineDocumentReport  style={{fontSize: "20px", color: "grey"}} />,
    path: "/reports",
  },

  /* ── Settings ────────────────────────────────────────────────────────── */
  {
    text: "Adminstration",
    icon: <MdOutlineAdminPanelSettings  style={{fontSize: "20px",}} />,
    path: "/adminstration",
    startsGroup: true,
  },
];
